var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackImage5Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 181,
    viewBox: "0 0 107 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.182 3.05176e-05L109.182 148.913L93.3384 164.756C72.7779 185.317 39.4427 185.317 18.8822 164.756C-1.67836 144.196 -1.67835 110.861 18.8822 90.3L109.182 3.05176e-05Z",
    fill: "url(#paint0_linear_368_514)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.124,
    y: 106.483,
    width: 45.4301,
    height: 74.4705,
    rx: 22.715,
    transform: "rotate(-135 32.124 106.483)",
    fill: "url(#paint1_linear_368_514)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_514",
    x1: -17.4088,
    y1: 201.047,
    x2: 204.477,
    y2: -20.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4789FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_514",
    x1: 54.8391,
    y1: 106.483,
    x2: 54.8391,
    y2: 180.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4789FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174599"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackImage5Mobile);
export default __webpack_public_path__ + "static/media/backImage5_mobile.cc1b00aa02752fc925d4f017dd64745f.svg";
export { ForwardRef as ReactComponent };